var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.86696 0.515223C3.71223 1.21956 1.22511 3.66314 0.446244 6.82354C-0.148748 9.23784 -0.148748 11.7622 0.446244 14.1765C1.22511 17.3369 3.71223 19.7804 6.86696 20.4848L7.3925 20.6021C9.76869 21.1326 12.2313 21.1326 14.6075 20.6021L15.133 20.4848C18.2878 19.7804 20.7749 17.3369 21.5538 14.1765C22.1487 11.7622 22.1487 9.23784 21.5538 6.82355C20.7749 3.66314 18.2878 1.21956 15.133 0.515221L14.6075 0.39789C12.2313 -0.13263 9.7687 -0.13263 7.3925 0.397889L6.86696 0.515223ZM6.9875 7.94863C6.64415 7.70148 6.167 7.78162 5.92176 8.12764C5.67651 8.47367 5.75604 8.95453 6.09938 9.20169L9.07578 11.3443C10.2269 12.1729 11.7732 12.1729 12.9243 11.3443L15.9007 9.20169C16.244 8.95453 16.3235 8.47367 16.0783 8.12764C15.8331 7.78162 15.3559 7.70148 15.0126 7.94863L12.0362 10.0912C11.4163 10.5374 10.5837 10.5374 9.96389 10.0912L6.9875 7.94863Z",
    fill: "#E19A47"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.6cdeb820774a984dad572762afaf5e00.svg";
export { ForwardRef as ReactComponent };